import sdl from '@jds/react-generated-sdl/JDSContentBlock';
import type { JDSContentBlockProps } from './interface';

import { componentsMap } from '../../../generators/componentMap';
import {
  createComponent,
  getCustomJSON,
  useTokenValues
} from '@jds/react-engine';

import { withLogic, ContentBlockType } from '../logic';

const Component = (props: ContentBlockType) => {
  const { platform } = useTokenValues();

  const json = sdl;
  const {
    size = 'xtra-small',
    ctaWrap = 'horizontal',
    invertCTA = false,
    shouldOverrideColor = false,
    singleButton = false,
    isTertiary = false,
    custom = '',
    ...rest
  } = props as any;
  return createComponent(
    json,
    {
      size,
      ctaWrap,
      invertCTA,
      shouldOverrideColor,
      singleButton,
      isTertiary,
      ...rest
    },
    'JDSContentBlock',
    componentsMap,
    getCustomJSON(custom || '') || {}
  );
};

const ContentBlock = withLogic(Component) as React.FC<ContentBlockType> & {
  slotName?: string;
};

ContentBlock.displayName = 'ContentBlock';
ContentBlock.slotName = 'jds_content_block';

export { ContentBlock, type JDSContentBlockProps };
